import { render, staticRenderFns } from "./RichContent.vue?vue&type=template&id=70e5447e&scoped=true"
import script from "./RichContent.vue?vue&type=script&lang=js"
export * from "./RichContent.vue?vue&type=script&lang=js"
import style0 from "./RichContent.vue?vue&type=style&index=0&id=70e5447e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5447e",
  null
  
)

export default component.exports